<template>
  <div class="flex w-fit items-center p-5 text-sm">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'FooterText',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>
